import axios from 'axios'

const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Headers': 'Authorization',
  },
})

export function sendPostRequest(url, data, config = null) {
  return api
    .post(url, data, config)
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}

export function sendGetRequest(url, config = null) {
  return api
    .get(url, config)
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}

export function sendPutRequest(url, data, config = null) {
  return api
    .put(url, data, config)
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}

export function sendDeleteRequest(url, config = null) {
  return api
    .delete(url, config)
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}

export default api
